import React from "react";
import {localField} from "../../../../_ae/helpers/UIHelper";
import {fetchStudentsForSelect, useStudentsForSelect} from "../../../../redux/students";
import {AEAutocompleteField} from "../../../../_metronic/_partials/controls/forms/AEField";
import {useDispatch} from "react-redux";

export const Field = ({...props}) => {
  const dispatch = useDispatch();
  const {data, metadata, isLoading} = useStudentsForSelect()

  const HandleSearch = search => {
    dispatch(
      fetchStudentsForSelect({
        ...metadata,
        filters: {
          ...metadata.filters,
          search
        }
      })
    )
  }

  return (
    <AEAutocompleteField
      name='student'
      label={'STUDENT'}
      options={data}
      getOptionLabel={role=>role[localField()]}
      onOpen={()=>{
        HandleSearch('')
      }}
      onInputChange={(event, search) => {
        HandleSearch(search)
      }}
      loading={isLoading}
      withFeedbackLabel={false}
      customFeedbackLabel={false}
      {...props}
    />
  )
}